import { combineReducers } from 'redux';
import { type IModule } from 'redux-dynamic-modules';

import { detailsApi } from '../../features/Details/data-layer/detailsApi';
import detailsReducer from '../../features/Details/data-store/detailsSlice';
import violationsEntitlementReducer from '../../features/ViolationsEntitlement/data-store/violationsEntitlementSlice';
import violationsReportReducer from '../../features/ViolationsReport/data-store/violationsReportSlice';
import violationsRoleReducer from '../../features/ViolationsRole/data-store/violationsRoleSlice';
import { violationsTabApi } from '../../features/ViolationsTab/data-layer/violationsTabApi';
import violationsTabReducer from '../../features/ViolationsTab/data-store/violationsTabSlice';
import violationsTimeReducer from '../../features/ViolationsTime/data-store/violationsTimeSlice';
import violationsUserReducer from '../../features/ViolationsUser/data-store/violationsUserSlice';

import { aagGlobalApi } from './globalApis';
import globalReducer from './globalSlice';

export const AAGReducer = combineReducers({
  global: globalReducer,
  details: detailsReducer,
  violationsTab: violationsTabReducer,
  time: violationsTimeReducer,
  user: violationsUserReducer,
  entitlement: violationsEntitlementReducer,
  role: violationsRoleReducer,
  report: violationsReportReducer,
});

// Club AAG reducer and API slices together and register middleware here
export const aagApiMiddleware = {
  middleware: [
    violationsTabApi.middleware,
    detailsApi.middleware,
    aagGlobalApi.middleware,
  ],
};

/**
 * Neo AAG module for home page store
 * @description Creates and returns a Redux Dynamic Module for the AAG feature.
 * This module includes the combined AAG reducer and API reducers for the violations tab
 * and global API endpoints.
 * @returns {IModule<unknown>} A Redux Dynamic Module containing the AAG reducers
 */
export function neoAAGModule(): IModule<unknown> {
  return {
    id: 'neoAAGModule',
    reducerMap: {
      aag: AAGReducer,
      [violationsTabApi.reducerPath]: violationsTabApi.reducer,
      [detailsApi.reducerPath]: detailsApi.reducer,
      [aagGlobalApi.reducerPath]: aagGlobalApi.reducer,
    },
  };
}
